export default __webpack_public_path__ + "images/257dfb0d82dd1d82d5e6c729d38bc097-EE_SlideDeckBOOK1024_15.png";